import { Navigate, Route, Routes } from 'react-router-dom'
import { useInstallations } from '@/features/installations/hooks/useInstallations'
import { LoadingScreen } from '@/shared/components'
import Installation from './installation'
import { useAppState } from '@/app/hooks/useAppState'
import ProductionRoute from './productionRoute'
import Reports from './reports'
import FinalizedReports from './finalized-reports'

export default function Dashboard() {
  const installationsQuery = useInstallations()
  const { selectedInstallationId } = useAppState()
  const installations = installationsQuery.data ?? []

  if (installationsQuery.isLoading) {
    return <LoadingScreen />
  }

  // If no installations exist, redirect to installation setup
  if (installations.length === 0) {
    return <Navigate to="/installation-setup" />
  }

  const installationId = selectedInstallationId || installations[0]?.id

  return (
    <Routes>
      <Route path="*" element={<Navigate to={`/dashboard/${installationId}`} />} />
      <Route path=":installationId/production-routes/:productionRouteId/finalized-reports">
        <Route index path="*" element={<FinalizedReports />} />
      </Route>
      <Route path=":installationId/production-routes/:productionRouteId/reports">
        <Route index path="*" element={<Reports />} />
      </Route>
      <Route path=":installationId/production-routes">
        <Route index path="*" element={<ProductionRoute />} />
      </Route>
      <Route path=":installationId">
        <Route index path="*" element={<Installation />} />
      </Route>
    </Routes>
  )
}
